import { useEffect } from "react";

import KButton from "@kikoff/components/src/v1/buttons/KButton";
import Card from "@kikoff/components/src/v1/cards/Card";
import { cls } from "@kikoff/utils/src/string";

import { useOverlaysController } from "@src/overlay";
import { track } from "@util/analytics";

import styles from "./phone_during_onboarding_section.module.scss";

interface PhoneDuringOnboardingSectionProps {}

const PhoneDuringOnboardingSection = ({}: PhoneDuringOnboardingSectionProps) => {
  const overlays = useOverlaysController();

  useEffect(() => {
    track.impression("Onboarding - Call Us Button");
  }, []);

  return (
    <div className={cls("column", styles["talk-to-us-section"])}>
      <Card className="text-center py-1 mb-1" outline>
        Not sure what to choose?
      </Card>
      <KButton
        variant="black-outline"
        onClick={() => {
          track.tap("Onboarding - Call Us Button");
          overlays.push("src/pages/dashboard/account/phone", {
            onboarding: true,
          });
        }}
        size="full-width"
      >
         Talk to us
      </KButton>
    </div>
  );
};

export default PhoneDuringOnboardingSection;
